/*
 * TODO: to be removed with PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS
 * LEGACY MILEAGE-LOCK group.
 *
 * This entity and the files listed below implement the pre-presets
 * `expense-mileage-lock` KVStore path (a single admin-locked rate). PAY-3067
 * supersedes it: `is_locked` becomes ExpenseMileageConfiguration.force_preset_rates,
 * and the single rate becomes a MileageRatePreset row (see the backend
 * `data_migration_expense_mileage` command).
 *
 * Retire the whole group once PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS is GA and
 * the backend `expense-mileage-lock` key is decommissioned. Grep "LEGACY MILEAGE-LOCK".
 *
 * Removable group:
 *  - entities/RequestMileageConfiguration/ (this dir)
 *  - data-access/api-models/RequestMileageConfigurationApiModel.ts
 *  - data-access/mappers/mapRequestMileageConfigurationApiModel.ts
 *  - data-access/mocks/mockGetRequestMileageConfigurationResponse.ts
 *  - business-logic/use-cases/GetRequestMileageConfiguration/
 *  - features/get-request-mileage-configuration/
 *  - IExpenseRepository.getMileageConfiguration + its ExpenseRepository impl
 *  - query-configs/expense.ts: requestMileageConfiguration()
 *  - CurrencyRepository.getCurrency (added for this path; confirm no other callers first)
 *
 * Refactored (NOT deleted) when presets land: the isLocked / mileageConfiguration
 * wiring in components/ExpenseLineItemForm/{MileageFields,ExpenseLineItemForm}.tsx
 * and mapExpenseItemToFormSchema.ts.
 */
import {
  Currency,
  type CurrencyConstructor,
} from '@webapp/core/entities/external/Currency'

export interface RequestMileageConfigurationConstructor {
  rate: number
  currency: CurrencyConstructor
  isLocked: boolean
}

export class RequestMileageConfiguration {
  readonly rate: number
  readonly currency: Currency
  readonly isLocked: boolean

  constructor(data: RequestMileageConfigurationConstructor) {
    this.rate = data.rate
    this.currency = new Currency(data.currency)
    this.isLocked = data.isLocked
  }
}
